import React, { useContext, useEffect, useRef } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link, useNavigate, useLocation } from "react-router-dom";

// styles
import {
  SettingBoxScroll,
  MenuItem,
  MenuItemSmall,
  MenuPauseAlarmBtn,
  MenuPauseAlarmIcon,
  SaveButton,
  Configbox,
  MenuItemLabel,
  MenuImage,
  MenuItemAside,
  MenuImageContainer,
  MenuIcon,
  MenuIconText,
  MenuIconContainer,
  MenuIconWrapper,
  MenuItemButton,
} from "./SettingMenu.elements.js";

// images
import alarmOn from "../../img/icons/alarm-on.png";
import alarmPause from "../../img/icons/alarm-pause-white.png";

const SettingMenu = ({ setting }) => {
  const navigate = useNavigate();

  const { state, setState } = useContext(AppContext);

  const scrollBoxRef = useRef(null);

  const location = useLocation();

  const disableNumeric = () => {
    setState((prevState) => ({ ...prevState, disableChangeNumeric: true }));
  };

  useEffect(() => {
    const scrollBoxElement = scrollBoxRef.current;

    const resetScrollPosition = () => {
      scrollBoxElement.scrollTop = 0;
    };

    resetScrollPosition();
  }, [location]);

  const clickHandler = (menuItem) => {
    if (menuItem.title === "Manual") {
      setState((prevState) => ({ ...prevState, spoContinuous: false }));
    } else if (menuItem.title === "Continuous") {
      setState((prevState) => ({ ...prevState, spoContinuous: true }));
    } else if (menuItem.title === "Annotate Arrhy: Off") {
      setState((prevState) => ({
        ...prevState,
        annotate: !prevState.annotate,
        annotateOrRelearn: !prevState.annotateOrRelearn,
      }));
    } else if (menuItem.title === "Relearn Arrhy") {
      setState((prevState) => ({
        ...prevState,
        relearn: true,
      }));
    } else if (menuItem.bannerName === "Initiate Alarms") {
      setState((prevState) => ({
        ...prevState,
        initiateAlarms: true,
        startInitiateAlarms: true,
      }));
    } else if (menuItem.bannerName === "Alarms On") {
      setState((prevState) => ({
        ...prevState,
        alarmsPause: !prevState.alarmsPause,
        xTachyAlarmAlert: !prevState.xTachyAlarmAlert,
      }));
    } else if (menuItem.title === "HR" && !state.ecg) {
      setState((prevState) => {
        const updatedNumericValues = [...prevState.numericValues];
        updatedNumericValues[0] = {
          ...updatedNumericValues[0],
          box: {
            ...updatedNumericValues[0].box,
            hr: true,
            spo: false,
            pvc: false,
            pulse: false,
            rr: false,
            st: false,
            qtc: false,
          },
        };

        return {
          ...prevState,
          ecg: true,
          ecgOffWave1: false,
          ecgOffWave2: false,
          numericValues: updatedNumericValues,
        };
      });
    } else if (menuItem.functionName === "changenumeric") {
      setState((prevState) => {
        const updatedBoxes = prevState.numericValues.map((boxy) => {
          if (boxy.isSelected && menuItem.title === "Pulse") {
            return {
              ...boxy,
              box: {
                hr: false,
                spo: false,
                pvc: false,
                pulse: true,
                rr: false,
                st: false,
                qtc: false,
              },
            };
          } else if (boxy.isSelected && menuItem.title === "HR") {
            return {
              ...boxy,
              box: {
                hr: true,
                spo: false,
                pvc: false,
                pulse: false,
                rr: false,
                st: false,
                qtc: false,
              },
            };
          } else if (boxy.isSelected && menuItem.title === "RR") {
            return {
              ...boxy,
              box: {
                hr: false,
                spo: false,
                pvc: false,
                pulse: false,
                rr: true,
                st: false,
                qtc: false,
              },
            };
          } else if (boxy.isSelected && menuItem.title === "QTC") {
            return {
              ...boxy,
              box: {
                hr: false,
                spo: false,
                pvc: false,
                pulse: false,
                rr: false,
                st: false,
                qtc: true,
              },
            };
          } else if (boxy.isSelected && menuItem.title === "SpO₂") {
            return {
              ...boxy,
              box: {
                hr: false,
                spo: true,
                pvc: false,
                pulse: false,
                rr: false,
                st: false,
                qtc: false,
              },
            };
          } else if (boxy.isSelected && menuItem.title === "PVC") {
            return {
              ...boxy,
              box: {
                hr: false,
                spo: false,
                pvc: true,
                pulse: false,
                rr: false,
                st: false,
                qtc: false,
              },
            };
          } else if (boxy.isSelected && menuItem.title === "ST") {
            return {
              ...boxy,
              box: {
                hr: false,
                spo: false,
                pvc: false,
                pulse: false,
                rr: false,
                st: true,
                qtc: false,
              },
            };
          } else {
            return { ...boxy };
          }
        });

        return {
          ...prevState,
          numericValues: updatedBoxes,
        };
      });
    }
  };

  const menu = setting.settings.map((menuItem, index) => {
    const title =
      menuItem.title === "Mode: Manual" && state.spoContinuous
        ? "Mode: Continuous"
        : menuItem.title === "Annotate Arrhy: Off" && state.annotate
        ? "Annotate Arrhy: On"
        : menuItem.title;

    // for menuitem text boxes + labels
    if (menuItem.text) {
      const menuText = menuItem.text.map((copy, index1) => {
        const image =
          copy.img &&
          copy.img.map((img) => {
            return (
              <MenuImageContainer key={img.id}>
                <MenuImage src={img.imgUrl}></MenuImage>
              </MenuImageContainer>
            );
          });

        const aside =
          copy.aside &&
          copy.aside.map((label) => {
            return (
              <div key={label.id}>
                {" "}
                <MenuItemLabel>{label.aside}</MenuItemLabel>
              </div>
            );
          });

        const labels = copy.label.map((label, index1) => {
          return (
            <div key={label.id}>
              <MenuItemLabel>{label.label}</MenuItemLabel>
            </div>
          );
        });

        const text = copy.text.map((text, index2) => {
          return (
            <div key={text.id}>
              <MenuItemLabel indent>{text.text}</MenuItemLabel>
            </div>
          );
        });

        return (
          <div key={copy.id}>
            <MenuItemAside>{aside}</MenuItemAside>
            {labels}
            {text}
            {image}
          </div>
        );
      });

      return (
        <MenuItem gray key={menuItem.id}>
          {menuText}
        </MenuItem>
      );
    }

    return (
      <div key={menuItem.bannerName ? menuItem.bannerName : menuItem.title}>
        {menuItem.functionButton && (
          <MenuItemButton
            key={menuItem.title}
            onClick={() => clickHandler(menuItem)}
          >
            {menuItem.title === "Config" ? (
              <Configbox>
                {menuItem.title}
                <SaveButton>Save</SaveButton>
              </Configbox>
            ) : (
              // menuItem.title
              title
            )}
          </MenuItemButton>
        )}

        {menuItem.link && (
          <>
            {state.disableChangeNumeric &&
            menuItem.title === "Change Numeric" ? (
              <MenuItem gray> {title}</MenuItem>
            ) : (
              <Link
                key={menuItem.title}
                // to={menuItem.clickTo}
                // to={
                //   menuItem.title === "Change Numeric" && fromMainSetupPage
                //     ? "#"
                //     : menuItem.clickTo
                // }
                to={
                  menuItem.title === "Change Numeric" &&
                  window.history.back === "/settings/mainsetup"
                    ? "#"
                    : menuItem.clickTo
                }
                onClick={(e) => {
                  if (menuItem.title === "Start SpO₂") {
                    if (state.spoContinuous === false) {
                      setState((prevState) => ({
                        ...prevState,
                        initiateSpo2start: true,
                        spoStart: false,
                        // spoStart: !prevState.spoStart,
                        currentPageIndex: 0,
                        refreshKey: prevState.refreshKey + 1,
                        // spoStartimg: (""),
                      }));
                      navigate("/", { replace: true });
                    } else {
                      e.preventDefault();
                      // Handle the case when state.spoContinuous is true
                      // You can add your desired code here
                    }
                  }
                  // if (menuItem.title === "Relearn Arrhy" && state.annotate) {
                  //   setState((prevState) => ({
                  //     ...prevState,
                  //     relearn: true,
                  //     annotate2Img: false,
                  //     annotate1Img: false,
                  //     masterRelearn: true,
                  //     currentPageIndex: 0,
                  //     // annotate: true,
                  //   }));
                  // }
                  if (menuItem.title === "Relearn Arrhy") {
                    setState((prevState) => ({
                      ...prevState,
                      relearn: true,
                      annotate2Img: false,
                      annotate1Img: false,
                      masterRelearn: true,
                      currentPageIndex: 0,
                      annotateOrRelearn: true,
                    }));
                  }

                  if (menuItem.mainsetup) {
                    disableNumeric();
                    // setState((prevState) => ({...prevState, disableChangeNumeric}))
                  }
                }}
                disabled={state.spoContinuous}
              >
                {menuItem.title === "Start SpO₂" && state.spoContinuous ? (
                  <MenuItem gray key={menuItem}>
                    {title}
                  </MenuItem>
                ) : (
                  <MenuItem>
                    {title}
                    {menuItem.icon && (
                      <MenuIconContainer>
                        {menuItem.icon && menuItem.title === "Battery: 100%" ? (
                          <MenuIconWrapper flexend>
                            <MenuIcon src={menuItem.icon}></MenuIcon>
                          </MenuIconWrapper>
                        ) : (
                          <>
                            <MenuIconWrapper>
                              <MenuIcon src={menuItem.icon}></MenuIcon>
                            </MenuIconWrapper>
                            <MenuIconText>{menuItem.iconText}</MenuIconText>
                          </>
                        )}
                      </MenuIconContainer>
                    )}
                  </MenuItem>
                )}
              </Link>
            )}
          </>
        )}

        {menuItem.gray && (
          <MenuItem gray key={menuItem}>
            {menuItem.label ? (
              <MenuItemLabel>{menuItem.title}</MenuItemLabel>
            ) : (
              menuItem.title
            )}
          </MenuItem>
        )}

        {menuItem.banner &&
          menuItem.bannerName === "Initiate Alarms" &&
          !state.initiateAlarms && (
            <MenuPauseAlarmBtn
              onClick={() => clickHandler(menuItem)}
              key={menuItem.bannerName}
            >
              Initiate Alarm Simulation
            </MenuPauseAlarmBtn>
          )}

        {menuItem.banner &&
          menuItem.bannerName === "Alarms On" &&
          state.initiateAlarms && (
            <MenuPauseAlarmBtn onClick={() => clickHandler(menuItem)}>
              {state.alarmsPause && (
                <>
                  <MenuPauseAlarmIcon>
                    <img
                      src={alarmOn}
                      style={{
                        height: "20px",
                        padding: "0",
                        paddingBottom: ".1em",
                      }}
                    />
                  </MenuPauseAlarmIcon>

                  <div>{menuItem.bannerName}</div>
                </>
              )}

              {!state.alarmsPause && (
                <>
                  <MenuPauseAlarmIcon>
                    <img
                      src={alarmPause}
                      style={{
                        height: "20px",
                        padding: "0",
                        paddingBottom: ".1em",
                      }}
                    />
                  </MenuPauseAlarmIcon>

                  <div> Pause Alarms </div>
                </>
              )}
            </MenuPauseAlarmBtn>
          )}
      </div>
    );
  });

  return (
    <>
      <SettingBoxScroll ref={scrollBoxRef}>{menu}</SettingBoxScroll>
    </>
  );
};

export default SettingMenu;
